import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Loader from '../components/Loader'
import { getCookie } from '../Functions'
import { QRCodeSVG } from 'qrcode.react';

export default function Thankyou() {

  const [loading, setLoading] = useState(true);  // Track loading state
  const [order, setOrder] = useState([]);  // Track loading state
  const [error, setError] = useState(false);  // Track loading state


  const userID = getCookie('gbx_id')


  // async function ConfirmTransaction(id) {
  //   try {
  //     const response = await fetch('https://l7es38hi1f.execute-api.eu-central-1.amazonaws.com/default/giftbox_transaction?action=confirmTransaction', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',  // Adding the Content-Type header
  //       },
  //       body: JSON.stringify({ TransactionID: id , userID:userID }),  // Sending the TransactionID as JSON
  //     });

  //     if (!response.ok) {
  //       // Handling non-200 responses
  //       throw new Error(`Request failed with status ${response.status}`);
  //     }

  //     const responseData = await response.json();
  //     return responseData;
  //   } catch (e) {
  //     console.log('Error during confirmation:', e);
  //     return null;  // Returning null or you can customize the error return based on your needs
  //   }
  // }

  // Function to confirm the transaction
  const ConfirmTransaction = async (id, img , amount) => {


    try {
      setLoading(true);  // Start loading
      const response = await fetch('https://0l3a26rip1.execute-api.eu-central-1.amazonaws.com/live/giftbox_transaction?action=confirmTransaction', {
        method: 'POST',
        body: JSON.stringify({ TransactionID: id, userID: userID, image: img , price:amount }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error === 0) {
        setOrder(responseData.message)
        return responseData;
      } else {
        setError(true)
      }


    } catch (e) {
      console.log('Error during confirmation:', e);
      return null;
    } finally {
      setLoading(false);  // Stop loading after the process is done
    }
  };






  useEffect(() => {
    const fetchTransactionData = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const TransactionID = searchParams.get("TransactionID");
      const ImageURL = searchParams.get("image");
      const Price = searchParams.get("price");

      console.log("Transaction ID:", TransactionID);

      if (TransactionID) {
        const newOrder = await ConfirmTransaction(TransactionID, ImageURL ,Price);

        // Stop if ConfirmTransaction returns an error
        if (!newOrder || newOrder.error === 1) {
          console.log("Transaction failed. Data will not be stored.");
          return; // Exit early
        }

        // Retrieve existing gbx_data from sessionStorage
        const storedData = JSON.parse(sessionStorage.getItem("gbx_data")) || {};
        const userData = storedData.user || {}; // Ensure user data exists
        const storedVouchers = userData.vouchers || []; // Ensure vouchers exist

        const combinedOrder = {
          ...newOrder.message,  // Include all order details
          image: newOrder.image // Add the image separately
        };

        const updatedVouchers = [...storedVouchers, combinedOrder];

        // Update sessionStorage while keeping all other data intact
        const updatedData = {
          ...storedData,
          user: {
            ...userData,
            vouchers: updatedVouchers
          }
        };

        sessionStorage.setItem("gbx_data", JSON.stringify(updatedData));
      }
    };

    fetchTransactionData();
  }, []);


  function addThirtyPercent(num) {
    const increased = num * 1.3; // Add 30%
    return Math.ceil(increased); // Round up to the nearest integer
  }

  function parseLpaCode(code) {
    if (!code.startsWith("LPA:1$")) {
      return code;
    }

    const cleanedCode = code.replace("LPA:1$", "");
    const parts = cleanedCode.split("$");

    // Ensure we have exactly two parts
    if (parts.length !== 2) {
      return "Invalid code format";
    }

    // The first part is the SM-DP+ address (e.g., "smdp.io")
    const smdpAddress = parts[0];

    // The second part is the activation code (e.g., "K2-27D7HN-IP0UJ1")
    const activationCode = parts[1];

    // Return the SM-DP+ address and activation code in the desired format
    return `
     <div className="d-flex flex-row" style="gap: 20px;">
  <div>
    <div><b>SM-DP+ Address:</b></div>
    <div>${smdpAddress}</div>
  </div>

  <div>
    <div><b>Activation Code:</b></div>
    <div>${activationCode}</div>
  </div>
</div>
     

    `
  }




  return (
    <div style={{ height: '100vh' }} >
      <Navbar />


      <section className='container mt-12'  >
        <div className="flex flex-col items-center justify-center min-h-screen text-center "   >
          <div className="bg-light shadow-lg  p-8 max-w-lg br-10">
            <h2 className="text-3xl font-bold text-blue-600">Thank You for Your Order! 🎉</h2>
            <p className="mt-4 text-gray-700 text-dark">
              Your order has been successfully placed, and we’re excited to get it ready for you!
            </p>

            <div className="mt-6 text-left">
              <p className="text-lg text-dark">✅ <strong>Order Confirmation:</strong> A confirmation email has been sent to your inbox.</p>
              <p className="text-lg text-dark">🚚 <strong>Processing & Shipping:</strong> We’re preparing your items. You’ll receive a tracking link once your order ships.</p>
              <p className="text-lg text-dark">💬 <strong>Need Help?</strong> Our support team is here for you!</p>
            </div>


            <div>

              {loading ? (
                <div className='d-flex flex-row align-items-center justify-content-between mt-5 p-4' style={{ background: '#EFEBFF', borderRadius: "15px" }} >
                  <h4>Preparing Your Order </h4>
                  <div className="loader">
                  </div>
                </div>
              ) : (
                error ? <p></p> :
                  <table className="order-table">
                    <tbody>
                      <tr><td><b>Transaction ID</b></td><td>{order.id}</td></tr>
                      <tr>
                        <td><b>Pin Code</b></td>
                        <td>
                          {order?.product?.pin?.code ? (
                            order.product.pin.code
                          ) : order?.pin?.code ? (
                            <div dangerouslySetInnerHTML={{ __html: parseLpaCode(order.pin.code) }} />
                          ) : (
                            "No pin code available"
                          )}
                        </td>
                      </tr>
                      <tr><td><b>Status</b></td><td>{order.status.message}</td></tr>
                      <tr><td><b>Name</b></td><td>{order.beneficiary.first_name} {order.beneficiary.last_name}</td></tr>
                      <tr><td><b>Email</b></td><td>{order.beneficiary.email}</td></tr>
                      <tr><td><b>Mobile</b></td><td>{order.beneficiary.mobile_number}</td></tr>
                      <tr><td><b>Product Name</b></td><td>{order.product.name}</td></tr>
                      <tr><td><b>Product Description</b></td><td>{order.product.description}</td></tr>
                      <tr><td><b>Service Type</b></td><td>{order.product.service.name}</td></tr>
                      <tr>
                        <td><b>Price</b></td>
                        <td>
                          {order.prices.retail && order.prices.retail.amount !== null
                            ? `${order.prices.retail.amount} ${order.prices.wholesale.unit}`
                            : `${addThirtyPercent(order.prices.wholesale.amount)} ${order.prices.wholesale.unit}`}
                        </td>
                      </tr>
                      <tr><td><b>Creation Date</b></td><td>{new Date(order.creation_date).toUTCString()}</td></tr>

                      {order.product.pin ? (
                        <tr>
                          <td><b>Terms</b></td>
                          <td>
                            {order.product.pin.terms
                              ? order.product.pin.terms.split("\n").map((line, i) => (
                                <div key={i}>{line}</div>
                              ))
                              : order.product.pin.usage_info?.[0]}
                          </td>
                        </tr>
                      ) : null}

                      {/* Show pin code or QR for eSIM */}
                      {order.product.service.name.toLowerCase() === "esim" && (() => {
                        const pin = order?.pin?.code || order?.product?.pin?.code;
                        if (!pin) return null;

                        return (
                          <tr>
                            <td colSpan="2" style={{ paddingTop: "1rem" }}>
                              <b>eSIM Code:</b>
                              <div style={{ marginTop: "0.5rem" }}>
                                {pin.startsWith("LPA:") ? (
                                  <QRCodeSVG value={pin} size={128} />
                                ) : (
                                  <div>{pin}</div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })()}
                    </tbody>

                  </table>
              )}
            </div>


          </div>

        </div>
      </section>
      <Footer />
    </div>
  )
}
